import { customValuesShapePropType, scoresShapePropType } from "PFCore/base/prop_types/common_prop_types";
import PropTypes from "prop-types";

export const activityResponseShapePropType = PropTypes.shape({
  activity: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string,
    description: PropTypes.string
  }),
  scores: scoresShapePropType,
  custom_values: customValuesShapePropType
}).isRequired;
